export enum PatientTypePreRequisite  {
    all = 0,
    inPatient = 1,
    outPatient = 2,
    ER = 3
}
